import { COUNTRY_CODE } from '@/utils/intl.js';
import { format } from '@/utils/time.js';
import { mdiAccount } from '@mdi/js';

export default {
  data() {
    return {
      localCategories: [],
      currentDate: format(new Date(), 'iso-date'),
      currentDateT: null
    };
  },

  computed: {
    localCategoryCacheKey() {
      return [ this.currentDate, COUNTRY_CODE, this.global.profile?.org_id ];
    },

    withUserCategory() {
      // TODO: make the user category searchable
      return this.localCategories;

      // if (!this.global.profile || this.global.profile.anon)
      //   // Note that we don't have access to the 'isSignedIn' computed property from the 'global-storate' mixin here
      //   return this.localCategories;
      // return [ [ `[user:${this.global.profile.user_id}]Your designs`, mdiAccount, 'black', 'black--text' ] ].concat(this.localCategories);
    }
  },

  created() {
    this.updateCurrentDate();
  },

  destroyed() {
    clearTimeout(this.currentDateT);
  },

  methods: {
    async loadLocalCategories() {
      const [ date, country ] = this.localCategoryCacheKey;
      this.localCategories = await this.$call('get-local-categories', { date, country });
    },

    updateCurrentDate() {
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      const msToMidnight = midnight - (new Date());
      this.currentDateT = setTimeout(
        () => {
          this.currentDate = format(new Date(), 'iso-date');
          this.updateCurrentDate()
        },
        msToMidnight
      );
    }
  },

  watch: {
    localCategoryCacheKey: {
      immediate: true,
      handler(cur, prev) {
        if (!_.isEqual(cur, prev))
          this.loadLocalCategories();
      }
    },

    withUserCategory(v) {
      this.global.localCategories = v;
    }
  }
}
